export default "__VITE_ASSET__DMyPsL9___"